{
  "title": "Choose Your View",
  "description": "Salt features sermons, services, and more for the view that you select below.",
  "noLaunchpadsTitle": "Nothing to Choose From",
  "noLaunchpadsDescription": "This church hasn't set up any views, so there's no content to show."
}
